import { EventEmitter } from "events"

const NavigationEvents = new EventEmitter()

const ACCESS_DENIED_EVENT = "AccessDenied" as const

export { NavigationEvents, ACCESS_DENIED_EVENT }
